<template>
  <div>
    <v-card width="100%" min-height="100%" elevation="0">
      <v-card-text>
        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-chip
                  class="pointer"
                  color="gray"
                  label
                  outlined
                >
                  Sélectionné ({{ itemsSelected.length }})
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-data-table
                  v-model="itemsAffected"
                  :headers="headers"
                  show-select
                  :hide-default-footer="true"
                  :items="itemsSelected"
                  :items-per-page="-1"
                  height="350"
                  item-key="uuid"
                  @click:row="rowClick"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-chip
                  class="pointer"
                  color="gray"
                  label
                  outlined
                >
                  Non Sélectionné ({{ items.length }})
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-data-table
                  v-model="itemsNoAffected"
                  :headers="headers"
                  :hide-default-footer="true"
                  :items="items"
                  :items-per-page="-1"
                  show-select
                  item-key="uuid"
                  height="350"
                  @click:row="rowClick"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row justify="center" no-gutters class="pt-4">
          <v-btn v-if="canUserPerformAction" color="third" class="white--text" height="32" @click="selectItems">
            Sélectionner / Désélectionner
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

import store from '@/store';

export default {
  props: {
    headers: {
      type: Array,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    itemsSelected: {
      type: Array,
      default: null
    }
  },
  setup (props, context) {
    const panel = ref([]);
    const itemsAffected = ref([]);
    const itemsNoAffected = ref([]);

    const rowClick = (item, row, event) => {
      event.stopPropagation();
      row.select(!row.isSelected);
    };

    const selectItems = () => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      context.emit('updateSelected', { selected: itemsAffected.value, deselected: itemsNoAffected.value });
      itemsNoAffected.value = [];
      itemsAffected.value = [];
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    return { selectItems, panel, rowClick, itemsAffected, itemsNoAffected, canUserPerformAction };
  }
};

</script>
